export default function SuccessConfirmation() {
  return (
    <div>
      <h3>¡Hecho!</h3>
      <p>Contraseña cambiada con éxito.</p>
      <p>Ya puedes acceder en tu App con la nueva contraseña.</p>
    </div>
  );
}